module.exports = __webpack_public_path__ + "media/images/lb/880-07883cd49ee8de43de4418b0b9c16e6c.svg";